import type { TOC } from '@ember/component/template-only';

interface SpinnerSignature {
  Element: HTMLDivElement;
}

export const Spinner = <template>
  <div class="text-center py-5" ...attributes>
    <div class="spinner-border" role="status">
      <span class="visually-hidden">Loading...</span>
    </div>
  </div>
</template> satisfies TOC<SpinnerSignature>;
